import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { Questionnaire } from "consumerhouse-shared";
import React, { useMemo } from "react";
import { useContext, useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router";
import AuthContext from "../AuthContext";
import Alert from "../components/Alert";
import CenterContainer from "../components/CenterContainer";
import { QuestionnaireFillIn } from "../components/QuestionAnswer";
import Title from "../components/Title";
import { List as LoadingList } from "react-content-loader";
import { FillQuestionnaireWithId } from "./FillQuestionnaire";

export function TestQuestionnaire({ match }: RouteComponentProps<{ id: string }>) {
    const { client } = useContext(AuthContext);
    const history = useHistory();
    const restart = useMemo(() => {
        let params = new URLSearchParams(window.location.search);
        return params.get("restart") === "1";
    }, [window.location.search]);

    async function createFakeUser() {
        let dummyUser = await client.fetch("/user/register/dummy");
        console.log("Created dummy user", dummyUser);
        if (restart) {
            history.push(
                `/fill-questionnaire/${match.params.id}?accessToken=${encodeURIComponent(dummyUser.accessToken)}&redirect=${encodeURIComponent(
                    `/test-questionnaire/${match.params.id}?restart=1`
                )}`
            );
        } else {
            history.push(`/fill-questionnaire/${match.params.id}?accessToken=${encodeURIComponent(dummyUser.accessToken)}`);
        }
    }

    useEffect(() => {
        createFakeUser();
    }, [client, match.params.id]);

    return (
        <CenterContainer style={{ margin: "2em 0" }}>
            <LoadingList />
        </CenterContainer>
    );
}
